<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>View Supported Banks</h2>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive">
              <table id="all-banks" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th>#</th>
                  <th>Bank Name</th>
                  <th>Bank Code</th>
                  <th>Nibss Code</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th>#</th>
                  <th>Bank Name</th>
                  <th>Bank Code</th>
                  <th>Nibss Code</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let bank of banks;let i = index;">

                  <td>{{ i + 1 }}</td>
                  <td>&nbsp;
                    {{ bank?.bank_name }}
                  </td>
                  <td>{{ bank?.bank_code }}</td>
                  <td>{{ bank?.bank_nibss_code }}</td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>


